// @flow

export const CheckedTextConfig = {
    WITHOUT_CHILDREN: 'WITHOUT_CHILDREN',
    WITHOUT_CHILDREN_UNIQ: 'WITHOUT_CHILDREN_UNIQ',
    NESTED_PATH: 'NESTED_PATH',
    ALL_CAPTIONS: 'ALL_CAPTIONS',
};

export type CheckedTextConfigType = $Keys<typeof CheckedTextConfig>;
